declare const Office: any;

export interface MicrosoftUserInfo {
  id: string;
  displayName: string;
  mail: string;
  userPrincipalName: string;
}

export interface MicrosoftAuthResult {
  success: boolean;
  token?: string;
  userInfo?: MicrosoftUserInfo | null;
  error?: string;
}

export class MicrosoftAuthService {
  isSupported(): boolean {
    return typeof window !== 'undefined' &&
           typeof Office !== 'undefined' &&
           Office.auth &&
           typeof Office.auth.getAccessToken === 'function';
  }

  private async getSSOToken(): Promise<string> {
    
    try {
      const result = await Office.auth.getAccessToken({
        allowSignInPrompt: true,
        allowConsentPrompt: true
      });

      if (!result) {
        throw new Error('Failed to retrieve access token');
      }
  
      return result;
    } catch (error) {
      console.error('Error details:', {
        name: error.name,
        message: error.message,
        code: error.code
      });
      throw new Error(`Authentication failed: ${error.message || 'Unknown error'}`);
    }
  }

  async testSSOToken(): Promise<MicrosoftAuthResult> {
    try {
      const token = await this.getSSOToken();
      return {
        success: true,
        token: token,
        userInfo: null
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'SSO token test failed'
      };
    }
  }

  async authenticate(baseURL?: string): Promise<MicrosoftAuthResult> {
    try {
      const token = await this.getSSOToken();
      
      if (!baseURL) {
        return {
          success: true,
          token: token,
          userInfo: null
        };
      }
      return {
        success: true,
        token: token,
        userInfo: null
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Authentication failed'
      };
    }
  }
}

export const microsoftAuth = new MicrosoftAuthService();